import { r as registerInstance, h } from './index-77a9c9e7.js';
import { f as fO, a3 as sw } from './index.esm-429f75bd.js';
import './index.esm-ca0f9386.js';
import './index.esm-eadda9d7.js';

const BpSdkRoot = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.completedAt = undefined;
        this.disableWebSocket = false;
        this.enableLifecycleEvents = false;
        this.disableToolbar = false;
        this.storeLoaded = false;
    }
    onDisabledWebSocket(disableWebSocket) {
        fO().dispatch(sw({ enableWebsocket: !disableWebSocket }));
    }
    resetState() { }
    connectedCallback() {
        this.resetState();
    }
    componentWillLoad() {
        this.onDisabledWebSocket(this.disableWebSocket);
    }
    render() {
        return (h("bp-sdk-setup-container", { key: '2d9c3658704929a698eb1b872d667d47d13b4807' }, h("bp-sdk-queue-container", { key: '5999b65629569f5b4eb5946874598b2776e797a4' }), [
            !!this.enableLifecycleEvents && h("bp-sdk-custom-event-container", { key: 'd4c6868326b35ce6643c01a5d40634875c1c2453' }),
            !this.disableToolbar && h("bp-sdk-interview-toolbar", { key: '86db346d7113efc2879a5dec52b990fddda88890' }),
        ], h("slot", { key: 'd96dcc963622be806f4a925de77ef89a9e9a96fb' })));
    }
    static get watchers() { return {
        "disableWebSocket": ["onDisabledWebSocket"]
    }; }
};

export { BpSdkRoot as bp_sdk_root };
